import cx from 'classnames'
import styles from './experiment-favourite-cta.module.css'
import { IconProps } from '@cinch-nx/design-system-icons'

export interface ExperimentFavouriteCTAProps {
  isPending: boolean
  isSaved: boolean
  onClick: () => void
}

interface updatedIconProps extends IconProps<16 | 24> {
  type: string
}

const heartIcon = ({ type, size }: updatedIconProps) => {
  const iconName = `heart${type}Icon`

  return (
    <svg
      height={size}
      width={size}
      role="img"
      aria-hidden
      fill={'url(#svg-gradient-alpha)'}
      focusable={false}
    >
      <use href={`/used-cars/icons/sprite.svg#${iconName}`} />
    </svg>
  )
}

const ExperimentFavouriteCTA = ({
  isPending,
  isSaved,
  onClick,
}: ExperimentFavouriteCTAProps) => {
  const FAVOURITE_CAR = 'Add car to favourites'
  const UNFAVOURITE_CAR = 'Remove car from favourites'
  const FavouriteIcon = isSaved
    ? heartIcon({ type: 'Filled', size: 24 })
    : heartIcon({ type: 'Outline', size: 24 })

  return (
    <button
      type="button"
      aria-label={isSaved ? UNFAVOURITE_CAR : FAVOURITE_CAR}
      onClick={onClick}
      className={cx(styles['favouriteCta'], {
        [styles['favouriteCtaPending']]: isPending,
        [styles['favouriteCtaSaved']]: isSaved,
      })}
    >
      {FavouriteIcon}
    </button>
  )
}

export default ExperimentFavouriteCTA
